
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
	name: 'ZBacktop'
})
export default class ZBacktop extends Vue {
	@Prop({ default: 100 }) bottom!: number
}
